import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { fetchData } from '../../api/fetchJson'
import { orgPath } from '../../config/orgId'
import { Card, Empty, ErrorBanner, Loading, PageHeader } from '../../components/ui'

export type Vendor = {
  id: string
  name: string
  gst_number?: string | null
  contact_name?: string | null
  phone?: string | null
  email?: string | null
}

export function useVendors() {
  return useQuery<Vendor[]>({
    queryKey: ['vendors'],
    queryFn: () => fetchData<Vendor[]>(orgPath('/vendors')),
    staleTime: 30_000,
  })
}

export function VendorListPage() {
  const q = useVendors()
  if (q.isLoading) return <Loading />
  if (q.isError) return <ErrorBanner error={q.error} />
  return (
    <div>
      <PageHeader title="Vendors" />
      {!q.data || q.data.length === 0 ? (
        <Empty message="No vendors seeded." hint="Operator: re-run the demo seed." />
      ) : (
        <Card>
          <ul className="divide-y divide-surface-700 text-sm">
            {q.data.map((v) => (
              <li key={v.id} className="py-3">
                <Link to={`/vendors/${v.id}`} className="block hover:text-accent-400">
                  <div className="flex justify-between gap-3">
                    <div>
                      <div className="font-medium">{v.name}</div>
                      {v.contact_name && (
                        <div className="text-xs text-surface-400">{v.contact_name}</div>
                      )}
                    </div>
                    <div className="text-right text-xs text-surface-400">
                      {v.gst_number && <div>GST: {v.gst_number}</div>}
                      {v.phone && <div>{v.phone}</div>}
                    </div>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </Card>
      )}
    </div>
  )
}
